// cool animation showing a stylized 3d avatar using animation of svg paths

import React from "react";
import { IonItem, IonLabel, IonSpinner } from "@ionic/react";
const spacesCalc = (n: number) => Array(n).fill("\u00A0").join("");
const spaces = spacesCalc(10);
interface LoadingAnimationProps {
  messages: string[];
}
export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  messages,
}) => {
    const [messageIndex, setMessageIndex] = React.useState(0);
    const [message, setMessage] = React.useState(messages[0]);
    React.useEffect(() => {
      const interval = setInterval(() => {
        setMessageIndex((messageIndex + 1) % messages.length);
        setMessage(messages[messageIndex]);
      }, 1000 *3 );
      return () => clearInterval(interval);
    }, [messageIndex]);  
  return (
    <IonItem className="ion-text-center w-[50%] h-[50%] text-3xl opacity-50">
    <IonLabel className="overflow-hidden">{message}</IonLabel>
    <IonSpinner name="circular" className="h-[100%]"></IonSpinner>
  </IonItem>

  );
}
   